import { START_LOADING, END_LOADING } from "./loading_actions";
import { postQuickRegister } from "../../utils/api";
import { TITLE_ERROR, TITLE_NOTIFICATION, TEXT_QUICK_REGISTER_SUCCESS } from "../../utils/constants";
import { SET_PORTAL_API } from "./portal_actions";
import { REQUEST_GET_ME_SUCCESS } from "./user_actions";
import { SET_CUSTOMER } from "./customer_actions";
import { NEW_ORDER_SET_PRODUCTS } from "./new_order_actions";
import { idProdutsInOrders, convertCartToOrderProductsList } from "../../utils/util_functions";


export const EDIT_FIRST_NAME_QUICK_REGISTER = 'EDIT_FIRST_NAME_QUICK_REGISTER';
export const EDIT_LAST_NAME_QUICK_REGISTER = 'EDIT_LAST_NAME_QUICK_REGISTER';
export const EDIT_SURNAME_QUICK_REGISTER = 'EDIT_SURNAME_QUICK_REGISTER';
export const EDIT_EMAIL_QUICK_REGISTER = 'EDIT_EMAIL_QUICK_REGISTER';
export const EDIT_PHONE_QUICK_REGISTER = 'EDIT_PHONE_QUICK_REGISTER';
export const RESET_QUICK_REGISTER_FORM = 'RESET_QUICK_REGISTER_FORM';
export const SWITCH_CHECKBOX_PERMISSION_QUICK = 'SWITCH_CHECKBOX_PERMISSION_QUICK';


export const postRegisterThunk = (first_name, last_name, surname, email, phone, navigate, productsInCart) => {
  return function (dispatch) {
    dispatch({ type: START_LOADING });

    postQuickRegister(first_name, last_name, surname, email, phone)
      .then(data => {
        dispatch({ type: RESET_QUICK_REGISTER_FORM });
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_NOTIFICATION,
          text: TEXT_QUICK_REGISTER_SUCCESS
        });
        dispatch({
          type: REQUEST_GET_ME_SUCCESS,
          first_name: data.first_name,
          last_name: data.last_name,
          surname: data.surname,
          email: data.email,
          phone: data.phone,
          is_active: data.is_active,
          discount_level: data.discount_level,
          role: data.role,
          perm_news: data.perm_news,
          perm_system_messages: data.perm_system_messages,
          last_ship_name: data.last_ship_name,
          last_ship_description: data.last_ship_description,
          pre_last_ship_name: data.pre_last_ship_name,
          pre_last_ship_description: data.pre_last_ship_description
        });
        dispatch({ type: SET_CUSTOMER, customer: data });
        const convertedList = convertCartToOrderProductsList(productsInCart, data);
        dispatch({
          type: NEW_ORDER_SET_PRODUCTS,
          payload: convertedList
        });
      })
      .catch(error => {
        console.log('error =', error);
        dispatch({ type: RESET_QUICK_REGISTER_FORM });
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: Object.values(error)
        });
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      });
  }
}
